

















import { UIModel } from "../UIModel";
import { Prop, Component, Vue } from "vue-property-decorator";

@Component({
	components: {},
})
export default class Index extends Vue {
	@Prop()
	public model!: UIModel;
}
